import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { HBox, VBox } from '../../../components/Box';
import DatePicker from 'react-datepicker';
import { createInvoice, fetchInvoice, resetInvoiceValues, setNewInvoiceValue } from '../actions';
import { Content } from '../../../components/Content';
import _ from 'lodash';
import { INVOICE_DIRECTIONS, REQUEST_INVOICE } from '../constants';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { fetchCompany, setCompanyProperty } from '../../Companies/actions';
import { calculateFinancialAmounts } from '../actions';
import { selectCompany, selectInvoice, selectInvoiceById, selectNewInvoice } from '../selectors';
import { IncomingCostTypes, OutgoingCostTypes } from '../constants';
import { getPropByName } from '../../../utils/props';
import { SelectCreditorModal } from '../../Vehicles/pages/create/AddVehicleModals/AddCreditorModal/SelectVehicleCreditorCompany';
import { SelectClientToOrder } from '../../Vehicles/components/AddToOrderModals/SelectClient/SelectClientToOrderModal';
import { ProductAndCostsModal } from '../components/ProductsAndCostsModal';
import { selectNewOrder, selectVehicle } from '../../Vehicles/selectors';
import { formatedDateNow, getDaysBetweenDates } from '../../Companies/helpers';
import { WIENTJES_INSTALATION } from '../../../containers/App/constants';
import { selectConfig, selectWork } from '../../Api/selectors';
import { Loader } from '../../../components/Loader';
import { setNewOrderValue } from '../../Vehicles/actions';

dayjs.extend(customParseFormat);

const Container = styled.div``;

const Address = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(33% - 10px);
  margin: 6px 0;
  font-size: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const INCOMING_COSTS_OPTIONS = Object.values(IncomingCostTypes)?.map(cost => ({
  value: cost,
  label: cost.toLowerCase().replaceAll('_', ' '),
}));

const OUTGOING_COSTS_OPTIONS = Object.values(OutgoingCostTypes)?.map(cost => ({
  value: cost,
  label: cost.toLowerCase().replaceAll('_', ' '),
}));

const STATE = {
  showProductsAndCostsModal: false,
  showCompanyModal: true,
  direction: 'outgoing',
  selectedCompanyId: null,
  selectedCompanyLabel: null,
  editCompany: true,
  selectedTransport: null,
  selectedTransportLabel: '',
  releaseBeforeIncoming: false,
  releaseBeforeOutgoing: false,
  date: null,
  dueDate: null,
  selectedUserLabel: null,
  selectedUserId: null,
  selectedAddress: null,
  selectedVehicle: null,
  editVehicle: true,
  excludeBTW: 1,
  excludeBTWLabel: 'Excl. BTW',
  price: '',
  selectedCost: null,
  selectedCostLabel: '',
  addedCosts: [],
  addedCostsLabels: [],
  bpmValue: null,
  isFinal: false,
  financialTotalAmount: null,
  economicalTotalAmount: null,
  invoiceSubjects: [],
  type: 'invoice',
  step: 1,
};

/* eslint-disable react/prefer-stateless-function */
class ProductInvoiceCreateComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  componentDidMount() {
    if (this.props.invoiceId) {
      this.props.fetchInvoice(result => {
        this.props.setValue(result?.outgoingCompanyId, 'outgoingCompanyId');
        this.props.setValue(result?.financialContactId, 'financial_contact');
        this.props.setValue(result?.financialContactId, 'client');
        if (result?.emailTo) {
          this.props.setValue(result?.emailTo, 'send_to_email');
          this.props.setValue('1', 'includeManual');
        }
      });
    }
  }

  onDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('date', date);
    return this;
  }

  onDueDateChange(value) {
    let date = dayjs(value).format('YYYY-MM-DD hh:mm:ss');
    this.updateState('dueDate', date);
    return this;
  }

  onPaidDateChange(value) {
    this.updateState('paidDate', value);
    return this;
  }

  onDesiredDeliveryDateChange(value) {
    this.updateState('desiredDeliveryDate', value);
    return this;
  }

  get direction() {
    return this.props.match.params.direction;
  }

  get vehicleId() {
    let vehicleId = this.props.vehicleId || null;
    if (this.props.copyFromInvoice?.vehicleId) {
      vehicleId = this.props.copyFromInvoice?.vehicleId;
    }

    return vehicleId;
  }

  get dto() {
    const selectedCompanyId = this.props.values?.creditor_company;

    return {
      separateInvoice: {
        date: this.state.date,
        direction: this.direction,
        vehicleId: this.vehicleId,
        //discount: this.state.discount,
        dueDate: this.state.dueDate,
        //desiredDeliveryDate: this.state.desiredDeliveryDate,
        // economicalTotalAmount: this.state.economicalTotalAmount,
        financialTotalAmount: this.state.financialTotalAmount,
        isFinal: this.state.isFinal,
        //paidDate: this.state.paidDate,
        //payments: this.state.payments,
        //incoming: this.state.incoming,
        // statusId: this.state.status,
        type: this.state.type ?? 'invoice',
        //userCreatorId: this.state.userCreatorId,
        incomingCompanyId: this.direction === 'incoming' ? selectedCompanyId : null,
        outgoingCompanyId: this.direction === 'outgoing' ? this.props.values?.outgoingCompanyId : null,
        creditor: this.direction === 'incoming' ? this.props.values?.creditor : null,
        financialContactId: this.props.values?.includeFinancialContact === '1' ? this.props.values?.financial_contact : null,
        outgoingUserId: this.props.values?.client || null,
        emailContactId: this.props.values?.includeFinancialContact === '1' ? this.props.values?.financial_contact : null,
        emailTo: this.props.values?.send_to_email || null,
        // contactId: this.props.values.seller || null,

        transportLocationId: this.state?.selectedAddress?.id ?? null,
        transport: this.direction === 'incoming' ? this.state.selectedTransportLabel : null,
        release_before_incoming_transport: this.direction === 'incoming' ? this.state.releaseBeforeIncoming : null,
        release_before_outgoing_transport: this.direction === 'outgoing' ? this.state.releaseBeforeOutgoing : null,
        subjectType: this.props.match.params.type === 'product' ? this.props.match.params.type : null,
      },
      invoiceSubjects: this.state.invoiceSubjects,
      relationSources: this.state.relationSources?.map(s => {
        return { description: s.description };
      }),
    };
  }

  get isSetNotApprovedCompany() {
    const putOnApprovedDate = getPropByName(this.props.fetchedCompany, 'put_on_approved_date');
    const companyStatus = getPropByName(this.props.fetchedCompany, 'status');

    return (
      this.props.config.appClientId == WIENTJES_INSTALATION.APP_CLIENT_ID &&
      companyStatus == '1' &&
      putOnApprovedDate &&
      getDaysBetweenDates(putOnApprovedDate, formatedDateNow()) > 365
    );
  }

  onCreate(addedProducts) {
    let data = this.dto;

    data.separateInvoice.costs = addedProducts?.costs;
    data.separateInvoice.products = addedProducts?.products;
    data.separateInvoice.oneTimeProducts = addedProducts?.oneTimeProducts;
    data.applyDefaultTasks = addedProducts?.applyDefaultTasks;

    this.props.create(data, result => {
      if (result?.id) {
        if (this.isSetNotApprovedCompany) {
          this.props.setCompanyProperty(this.props.fetchedCompany?.id, 'status', '0', () => {});
        }
        const redirectUrl = this.vehicleId
          ? `/invoices/product-invoices/vehicle/${this.vehicleId}/invoice/${result?.id}`
          : `/invoices/product-invoices/invoice/${result?.id}`;
        this.props.resetValues();
        this.to(redirectUrl);
      }
    });
  }

  onIsFinalChanged() {
    this.setState(prev => {
      return { ...prev, isFinal: !prev.isFinal };
    });
  }

  reset() {
    this.setState(prev => {
      return { ...STATE, invoiceSubjects: STATE.invoiceSubjects, relationSources: STATE.relationSources };
    });
  }

  get resetUrl() {
    let url = this.tofn('/invoices');
    if (this.vehicleId) {
      url = this.tofn(`/vehicles/${this.vehicleId}`);
    }

    if (this.props.invoiceId) {
      url = this.tofn('/invoices');
    }

    return url;
  }

  // updated methods
  setDirection = e => {
    const { value } = e;
    this.setState({
      direction: value,
    });
  };

  setExclBTW = e => {
    const { value, label } = e;
    this.setState({
      excludeBTW: value,
      excludeBTWLabel: label,
    });
  };

  toggleEditCompany = () => {
    this.setState({ editCompany: true });
  };

  toggleEditVehicle = () => {
    this.setState({ editVehicle: true });
  };

  onChangeCompanySelection(company) {
    this.setState(
      prev => ({
        ...prev,
        selectedCompanyLabel: company.label ?? '',
        selectedCompanyId: company.id,
        editCompany: false,
      }),
      this.props.fetchCompany(company.id, result => {
        if (result.id) {
          const defautltTransportType = getPropByName(result, 'prefence_incoming_transport');
          const defaultReleaseBeforeIncoming = getPropByName(result, 'release_before_incoming_transport');
          const defaultReleaseBeforeOutgoing = getPropByName(result, 'release_before_outgoing_transport');
          const isBlockIncoming = getPropByName(result, `incoming_block`);
          const isBlockOutgoing = getPropByName(result, `outgoing_block`);
          this.setState({ incoming_block: isBlockIncoming, outgoing_block: isBlockOutgoing });
          defautltTransportType
            ? this.setState({
                selectedTransport: defautltTransportType,
                selectedTransportLabel: defautltTransportType,
                defautltTransport: defautltTransportType,
              })
            : this.setState({
                selectedTransport: null,
                selectedTransportLabel: '',
                defautltTransport: '',
              });
          defaultReleaseBeforeIncoming
            ? this.setState({
                releaseBeforeIncoming: defaultReleaseBeforeIncoming,
              })
            : this.setState({ releaseBeforeIncoming: false });

          defaultReleaseBeforeOutgoing
            ? this.setState({
                releaseBeforeOutgoing: defaultReleaseBeforeOutgoing,
              })
            : this.setState({ releaseBeforeOutgoing: false });
        }
      }),
    );
  }

  selectTransportType = e => {
    this.setState({ selectedTransport: e.value, selectedTransportLabel: e.label });
  };

  onReleaseTransportChange() {
    this.direction === 'incoming'
      ? this.setState(prev => {
          return { ...prev, releaseBeforeIncoming: !prev.releaseBeforeIncoming };
        })
      : this.setState(prev => {
          return { ...prev, releaseBeforeOutgoing: !prev.releaseBeforeOutgoing };
        });
  }

  onChangeVehicle = vehicle => {
    console.log(vehicle);
    this.setState(
      prev => ({
        ...prev,
        selectedVehicle: vehicle,
        editVehicle: false,
      }),
      () => {
        this.addInvoiceSubject('vehicle');
        this.addInvoiceSubject('BPM');
      },
    );
  };

  setCompanyUser = e => {
    this.setState({ selectedUserId: e.value, selectedUserLabel: e.label });
  };

  getUserOptions = () => {
    return this.props.fetchedCompany?.users?.map(user => {
      const name = user.properties?.find(p => p?.name?.name === 'name')?.value;
      const surname = user.properties?.find(p => p?.name?.name === 'surname')?.value;
      const fullName = name && surname ? `${name} ${surname}` : user?.email_address;
      return { value: user.id, label: fullName };
    });
  };

  handleSetAddress = address => {
    this.setState({ selectedAddress: address });
  };

  timeout(fn, ms, clear) {
    if (clear) clearTimeout(clear);
    let t = setTimeout(fn, ms);
    this._timeouts.push(t);
    return t;
  }

  onPriceChange = e => {
    const { value } = e.target;
    this.setState({ price: +value });
    this._t = this.timeout(this.calculateAmounts('vehicle', value), 300, this._t);
  };

  sanitizeValue(raw) {
    return raw === '' ? null : raw;
  }

  addInvoiceSubject = (type, costType) => {
    if (!this.state.selectedVehicle) return;
    const basicSubject = {
      type,
    };
    if (type === 'BPM') {
      basicSubject.description = 'BPM';
    }
    if (type === 'cost') {
      basicSubject.costType = costType;
      let _description = costType.toLowerCase().replaceAll('_', ' ');
      basicSubject.description = _description[0].toUpperCase() + _description.slice(1);
    }
    if (type === 'vehicle') {
      basicSubject.tax_type = this.state.selectedVehicle?.tax_type;
      basicSubject.vehicleId = this.state.selectedVehicle?.id;
    }
    console.log(basicSubject);
    if (this.state.invoiceSubjects?.length && type === 'vehicle') {
      this.setState(prev => ({ ...prev, invoiceSubjects: prev.invoiceSubjects.splice(0, 1, { ...basicSubject }) }));
    } else {
      this.setState(prev => ({ ...prev, invoiceSubjects: [...prev.invoiceSubjects, { ...basicSubject }] }));
    }
  };

  removeInvoiceSubject = (type, costType) => {
    const updated = this.state.invoiceSubjects.filter(is => is?.type !== type && is?.costType !== costType);
    const financialTotalAmount = updated.reduce((total, subject) => {
      total += +subject.price ?? 0;
      return total;
    }, 0);
    this.setState({ invocesSubjects: [...updated], financialTotalAmount });
  };

  calculateAmounts = (type, rawValue, cost_type) => {
    const { selectedVehicle, direction, excludeBTW, selectedCompanyId } = this.state;
    const value = !rawValue ? 0 : +rawValue;

    const subject = {
      subject_type: type,
      direction,
      salesAmounts: {},
      financialAmounts: {},
      incomingCompanyId: null,
      outgoingCompanyId: null,
    };

    if (type === 'vehicle') {
      subject.vehicleId = selectedVehicle?.id;

      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.salesAmounts.financial_price_excl_vat_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.salesAmounts.financial_price_incl_vat_bpm = value;
        }
        if (!!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.salesAmounts.financial_price_marge_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.salesAmounts.financial_price_marge_bpm = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.financialAmounts.financial_price_excl_vat_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'BTW') {
          subject.financialAmounts.financial_price_incl_vat_bpm = value;
        }
        if (!!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.financialAmounts.financial_price_marge_excl_bpm = value;
        }
        if (!excludeBTW && selectedVehicle?.tax_type === 'marge') {
          subject.financialAmounts.financial_price_marge_bpm = value;
        }
      }
    } else if (type === 'cost') {
      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW) {
          subject.salesAmounts.cost_price_excl_vat = value;
        } else {
          subject.salesAmounts.cost_price_incl_vat = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW) {
          subject.financialAmounts.cost_price_excl_vat = value;
        } else {
          subject.financialAmounts.cost_price_incl_vat = value;
        }
      }
    } else if (type === 'BPM') {
      if (direction === 'outgoing') {
        subject.outgoingCompanyId = selectedCompanyId;

        if (!!excludeBTW) {
          subject.salesAmounts.bpm_price_excl_vat = value;
        } else {
          subject.salesAmounts.bpm_price_incl_vat = value;
        }
      } else {
        subject.incomingCompanyId = selectedCompanyId;
        if (!!excludeBTW) {
          subject.financialAmounts.bpm_price_excl_vat = value;
        } else {
          subject.financialAmounts.bpm_price_incl_vat = value;
        }
      }
    }
    this.props.calculateFinancialAmounts(subject, result => {
      console.log(result);

      if (type !== 'vehicle') {
        delete result?.description;
      }

      const updatedSubjects = [...this.state.invoiceSubjects];

      const positionToUpdate = cost_type
        ? updatedSubjects.findIndex(sub => sub?.costType === cost_type)
        : updatedSubjects.findIndex(sub => sub?.type === type);
      console.log('subject pos: ', positionToUpdate);
      if (positionToUpdate >= 0) {
        updatedSubjects[positionToUpdate] = { ...updatedSubjects[positionToUpdate], ...result };
        const updatedTotal = updatedSubjects.reduce((total, subject) => {
          if (!!subject.price) {
            total += subject.price;
          }
          return total;
        }, 0);
        this.setState({ invoiceSubjects: [...updatedSubjects], financialTotalAmount: updatedTotal });
      }
    });
  };

  selectCost = e => {
    this.setState({ selectedCost: e.value, selectedCostLabel: e.label });
  };

  addCost = () => {
    if (!this.state.selectedCost || !this.state.selectedCostLabel) return;
    const newCostType = this.state.selectedCost;
    this.setState(
      prev => ({
        ...prev,
        addedCosts: [...prev.addedCosts, { type: prev.selectedCost, value: 0 }],
        addedCostsLabels: [...prev.addedCostsLabels, prev.selectedCostLabel],
        selectedCost: null,
        selectedCostLabel: '',
      }),
      this.addInvoiceSubject('cost', newCostType),
    );
  };

  removeCost = idx => {
    this.removeInvoiceSubject('cost', this.state.addedCostsLabels[idx]);
    this.setState(prev => ({
      ...prev,
      addedCosts: prev.addedCosts.filter((c, i) => i !== idx),
      addedCostsLabels: prev.addedCostsLabels.filter((c, i) => i !== idx),
    }));
  };

  onCostChange = (e, idx) => {
    const { value } = e.target;
    const updatedCosts = [...this.state.addedCosts];
    updatedCosts[idx].value = value;
    this.setState({ addedCosts: [...updatedCosts] });
    this._t = this.timeout(this.calculateAmounts('cost', value, this.state.addedCosts[idx].type), 300, this._t);
  };

  onBpmChange = e => {
    const { value } = e.target;
    this.setState({ bpmValue: value });
    this._t = this.timeout(this.calculateAmounts('BPM', value), 300, this._t);
  };

  get createDisabled() {
    return (
      this.state[`${this.direction}_block`] === '1' ||
      this.props.values?.creditor_company ||
      this.props.values?.outgoingCompanyId
    );
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container>
        {this.state.showProductsAndCostsModal && (
          <ProductAndCostsModal
            step="2"
            direction={this.direction}
            vehicle={this.props.vehicle}
            onConfirm={this.onCreate.bind(this)}
            company={this.props.fetchedCompany}
            reset={this.resetUrl}
            copiedSubjects={this.props.copyFromInvoice?.invoiceSubjects}
          />
        )}
        {this.direction == INVOICE_DIRECTIONS.INCOMING && this.state.showCompanyModal && (
          <SelectCreditorModal
            step={this.state.step}
            invoicePage
            reset={this.resetUrl}
            onConfirm={() => this.setState({ showProductsAndCostsModal: true, showCompanyModal: false })}
          />
        )}
        {this.direction == INVOICE_DIRECTIONS.OUTGOING && this.state.showCompanyModal && (
          <SelectClientToOrder
            step={this.state.step}
            invoicePage
            reset={this.resetUrl}
            onClose={this.resetUrl}
            onNextModal={() => this.setState({ showProductsAndCostsModal: true, showCompanyModal: false })}
          />
        )}
        <Content></Content>
        <HBox>
          <Button primary onClick={this.reset.bind(this)}>
            {this.lbl('invoice.create.reset')}
          </Button>
          <Button primary disabled={this.createDisabled} onClick={this.onCreate.bind(this)}>
            {this.lbl('invoice.create.createBtn')}
          </Button>
        </HBox>
      </Container>
    );
  }
}

ProductInvoiceCreateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    fetchedCompany: selectCompany(),
    values: selectNewInvoice(),
    vehicle: selectVehicle(ownProps?.vehicleId),
    config: selectConfig(),
    work: selectWork(REQUEST_INVOICE),
    copyFromInvoice: selectInvoiceById(ownProps.invoiceId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(dto, callback) {
      dispatch(createInvoice(dto, callback));
    },
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps.invoiceId, callback));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
    resetValues() {
      dispatch(resetInvoiceValues());
    },
    fetchCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
    setCompanyProperty(companyId, propertyName, propertyValue, callback) {
      dispatch(setCompanyProperty(companyId, propertyName, propertyValue, callback));
    },
    calculateFinancialAmounts(subject, callback) {
      dispatch(calculateFinancialAmounts(subject, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductInvoiceCreate = compose(withConnect, withRouter)(ProductInvoiceCreateComp);
